import { useEffect, useState } from "react";

const useBottomReached = () => {
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    const onScroll = () => setAtBottom((window.innerHeight + window.scrollY + 1) >= document.body.offsetHeight);
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return atBottom;
};

export default useBottomReached;
